import { TextField, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FONT_SIZES, PALETTE } from '~/assets/styles/base';

const Title = styled(Typography)`
  font-size: ${FONT_SIZES.title3};
  color: ${PALETTE.text.sub};
  margin-top: 20px;
`;
const NumericAnswer: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div>
      <Title>{t('registration.originalForm.manual.numAnswer.title')}</Title>
      <TextField
        sx={{ marginTop: '20px' }}
        inputProps={{
          style: {
            height: '48px',
            width: '709px',
          },
          readOnly: true,
          'data-testid': 'numAnswerComponent',
        }}
      />
    </div>
  );
};

export default NumericAnswer;
